import { Popover as BasePopover } from '@base-ui/react/popover';
import { cloneElement, type ReactElement } from 'react';

import { Button, type ButtonType } from '../Button';
import type { PopoverAlign, PopoverSide } from '../Popover';
import arrowStyles from '../shared/floating-arrow.module.css';
import styles from './Popconfirm.module.css';

export interface PopconfirmProps {
  children: ReactElement;
  className?: string;
  confirmType?: ButtonType;
  confirmText?: string;
  description?: string;
  onCancel?: () => void;
  onConfirm: () => void;
  side?: PopoverSide;
  align?: PopoverAlign;
  title: string;
}

export function Popconfirm({ align = 'start', cancelText = '取消', children, className, confirmText = '确定', confirmType = 'primary', description, onCancel, onConfirm, side = 'bottom', title }: PopconfirmProps & { cancelText?: string }) {
  return (
    <BasePopover.Root>
      <BasePopover.Trigger render={(triggerProps) => {
        /* Link 等本地触发器由自身控制视觉 type 与原生 button type，避免 Base UI 的 type 覆盖语义颜色。 */
        const safeTriggerProps = { ...triggerProps } as typeof triggerProps & { type?: string };
        delete safeTriggerProps.type;
        return cloneElement(children, safeTriggerProps);
      }} />
      <BasePopover.Portal>
        <BasePopover.Positioner align={align} className={styles.positioner} side={side} sideOffset={6}>
          <BasePopover.Popup className={[styles.popup, className].filter(Boolean).join(' ')}>
            <div className={styles.text}>
              <p className={styles.title}>{title}</p>
              {description ? <p className={styles.description}>{description}</p> : null}
            </div>
            <div className={styles.actions}>
              <Button onClick={() => { onCancel?.(); }} size="small" type="default">{cancelText}</Button>
              <Button onClick={onConfirm} size="small" type={confirmType}>{confirmText}</Button>
            </div>
            <BasePopover.Arrow className={[styles.arrow, arrowStyles.arrow].join(' ')} />
          </BasePopover.Popup>
        </BasePopover.Positioner>
      </BasePopover.Portal>
    </BasePopover.Root>
  );
}
